import { CosmicJSClient } from "../../apis/cosmicjs-client";
import { Tag } from "../../domain/help/help-entity";

const TAG_OBJECT_TYPE = "tags" as const;

const BUCKET = `graffer-console-contents` as const;

class TagListService extends CosmicJSClient {
  constructor() {
    super(BUCKET);
  }

  async fetchTagList(): Promise<Tag[]> {
    const result = await this.fetch<Tag>(
      JSON.stringify({
        type: TAG_OBJECT_TYPE,
      }),
      "id,slug,title",
      "-order",
    );
    return result.objects;
  }
}

export const tagListService = new TagListService();
